import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { sortBy } from 'lodash';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ApiService } from '@nrwl/common-lib';
import { Router } from '@angular/router';
import { NavigationProvider } from '@nrwl/navigation-abstract';
const testConfig = require('./payload/rebootRequest.json');

@Injectable({
  providedIn: 'root'
})
export class DataSourceService {
  deleteDevicesPath = '/agent/v1/state';
  updateDevicesPath = '/vibe/inventory/v3/updateDevices';
  removeDevicesPath = '/vibe/inventory/v3/removeDevices';
  agentManagerPath = '/agent/v1';
  agentControlProxyPath = '/agent/v1/proxy';
  uploadFilePath = '/agent/v1/agentimage';
  jmepUploadPath = '/uicomm/uploadFile';
  getJmepImagesList = '/uicomm/getJmepImageFiles';
  getJmepKeysInfoPath = '/uicomm/getJMEPKeysInfo';
  redistributeJMEPKeys = '/uicomm/redistributeJMEPKeys';
  validateJmepBulkRenamingFilePath = '/uicomm/validateJmepBulkRenamingFile';
  applyJmepBulkRenamingFilePath = '/uicomm/applyJmepBulkRenamingFile';
  getBulkRenamingFileJobStatusPath = '/uicomm/getBulkRenamingFileJobStatus';
  getFieldMappingFileSummaryPath = '/uicomm/getFieldMappingFileSummary';
  getAllBulkRenamingFilesInfo = '/uicomm/getAllBulkRenamingFilesInfo';
  getDownloadJmepFileStatusPath = '/uicomm/getDownloadJmepFileStatus';
  removeBulkRenamingFilePath = '/uicomm/removeBulkRenamingFile';
  getViewLastResultsPath = '/vibe/inventory/bulkconfig/results';
  auditPMFlowsPath = '/uicomm/auditPMFlows';
  emitPMFlowAuditPath = '/uicomm/emitPMFlowAudit';
  removePMAuditFilePath = '/uicomm/removePMAuditFile';
  saveServerConfigPath = '/uicomm/saveServerConfig';
  jmepDeletePath = '/agent/v1/delete';
  jmepDeleteAgent = '/uicomm/deleteJmepImageFiles';
  getEsamConfigPath = '/uicomm/getEsamConfig';
  updateEsamConfigPath = '/uicomm/updateEsamConfig';
  restartJMEPPath = '/uicomm/restartJMEP';
  resyncJMEPPath = '/uicomm/resyncJMEP';
  stopJMEPPath = '/uicomm/stopLoopbacksJMEP';
  jmepAlarmsPath = '/uicomm/getJMEPAlarms';
  jmepConfigPath = '/uicomm/getJMEPConfig';
  transferDevicesPath = '/uicomm/transferDevices';
  uploadJmepsBulkConfigFilePath = '/vibe/inventory/bulkconfig/files';
  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly navigator: NavigationProvider,
    private http: HttpClient
  ) {}

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  removeDataSourceItem$(item: any): Observable<any> {
    const id = encodeURIComponent(item.id);
    const url = `${this.deleteDevicesPath}?agentId=${id}&state=destroyed`;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.put$<any>(url, {});
  }

  // eslint-disable-next-line
  rebootDatasource$(item: any): Observable<any> {
    testConfig.agent.primary.id = item.name.label;
    const url = '/sbi/restconf/data/ietf-lmap-control:lmap';
    return this.rebootDatasourceItem(JSON.stringify(testConfig), url);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  restartDataSource$(jmepSvrUrl: any, jmepProbeArray: any): Observable<any> {
    return this.apiService.post$(this.restartJMEPPath, { url: jmepSvrUrl, probes: jmepProbeArray });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  resyncDataSource$(jmepSvrUrl: any, jmepProbeArray: any): Observable<any> {
    return this.apiService.post$(this.resyncJMEPPath, { url: jmepSvrUrl, probes: jmepProbeArray });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  stopLoopbackDataSource$(jmepSvrUrl: any, jmepProbeArray: any): Observable<any> {
    return this.apiService.post$(this.stopJMEPPath, { url: jmepSvrUrl, probes: jmepProbeArray });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  jmepAlarms(jmepSvrUrl: any, jmepId: any): Observable<any> {
    return this.apiService.post$(this.jmepAlarmsPath, { url: jmepSvrUrl, id: jmepId });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  jmepConfig(reqData: any): Observable<any> {
    return this.apiService.post$(this.jmepConfigPath, { reqData: reqData });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  sortDataByName(data: any) {
    return sortBy(data, device => device.getName().toLowerCase().trim());
  }

  // eslint-disable-next-line
  updateDataSourceState(dataId: any, state: any, type: any, item: any): Observable<any> {
    const id = encodeURIComponent(dataId);
    const url = `${this.deleteDevicesPath}?agentId=${id}&state=${state}`;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.put$<any>(url, {});
  }

  navigateToWizard(wizardId: string, defaultParams = {}): void {
    this.navigator.navigateToWizard([wizardId], {
      queryParams: {
        defaultParams: JSON.stringify(defaultParams)
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateWindowsAgentVersioninMinio(agentId: string): Observable<any> {
    const url = `${this.agentManagerPath}/updateWindowsAgentFirmware?agentId=` + agentId;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.put$<any>(url, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  rebootDatasourceItem(payload: any, url: string): Observable<any> {
    this.apiService.removeHeader('Authorization');
    //eslint-disable-next-line
    return this.apiService.post$<any>(url, payload);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadAgentFile(payload: FormData): Observable<any> {
    //eslint-disable-next-line
    return this.http.post(this.uploadFilePath, payload);
  }

  jmepUpload(payload: FormData): Observable<any> {
    return this.http.post(this.jmepUploadPath, payload);
  }

  getjmepImagesList(): Observable<any> {
    return this.apiService.post$<any>(this.getJmepImagesList);
  }

  getAllBulkRenamingFilesList(): Observable<any> {
    return this.apiService.post$<any>(this.getAllBulkRenamingFilesInfo);
  }

  getJmepKeysInfo(): Observable<any> {
    return this.apiService.post$<any>(this.getJmepKeysInfoPath);
  }

  getRedistributeJMEPKeys(): Observable<any> {
    return this.apiService.post$<any>(this.redistributeJMEPKeys);
  }

  nonJmepDelete(agentType: string, version: string): Observable<any> {
    return this.apiService.delete$<any>(this.uploadFilePath + '/' + agentType + '/' + version);
  }
  jmepDelete(imageName: string): Observable<any> {
    return this.apiService.post$<any>(this.jmepDeleteAgent + '/' + imageName);
  }

  jmepImageFiles(): Observable<any> {
    return this.apiService.get$<any>(this.jmepDeletePath);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProxy(): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.get$<any>(this.agentControlProxyPath);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createProxy(payload: string): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(this.agentControlProxyPath, payload);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateProxy(payload: string): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.put$<any>(this.agentControlProxyPath, payload);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeProxy(payload: string): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.delete$<any>(this.agentControlProxyPath + '/' + payload);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeManagedDevices(data: object, enableForceOption = false): Observable<any> {
    if (enableForceOption) {
      return this.apiService.delete$<any>(`${this.removeDevicesPath}?force=true`, data);
    } else {
      return this.apiService.delete$<any>(`${this.removeDevicesPath}`, data);
    }
  }
  //eslint-disable-next-line
  updateManagedDevice(data): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.updateDevicesPath}`, data);
  }
  //eslint-disable-next-line
  getEsamConfig(url): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.getEsamConfigPath}`, { url: url });
  }
  //eslint-disable-next-line
  updateEsamConfig(url, payload): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.updateEsamConfigPath}`, {
      url: url,
      option: payload
    });
  }

  validateJmepBulkRenamingFile(fileName: string): Observable<any> {
    return this.apiService.post$(this.validateJmepBulkRenamingFilePath + '/' + fileName);
  }

  applyJmepBulkRenamingFile(fileName: string): Observable<any> {
    return this.apiService.post$(this.applyJmepBulkRenamingFilePath + '/' + fileName);
  }

  getBulkRenamingFileJobStatus(jobId: string): Observable<any> {
    return this.apiService.post$(this.getBulkRenamingFileJobStatusPath + '/' + jobId);
  }

  getFieldMappingFileSummary(fileName: string): Observable<any> {
    return this.apiService.post$(this.getFieldMappingFileSummaryPath + '/' + fileName);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getDownloadJmepFileStatus(data: any): Observable<any> {
    return this.apiService.post$(this.getDownloadJmepFileStatusPath, { data });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  removeBulkRenamingFile(data: any): Observable<any> {
    return this.apiService.post$(this.removeBulkRenamingFilePath + '/' + data);
  }

  getViewLastResults(fileName: string): Observable<any> {
    return this.apiService.get$(
      `${this.getViewLastResultsPath}?fileName=` + fileName + `&groupName=rename`
    );
  }

  auditPMFlows(pmType: string): Observable<any> {
    return this.apiService.post$(this.auditPMFlowsPath, { pmType: pmType });
  }

  emitPMFlowAudit(): Observable<any> {
    return this.apiService.post$<any>(this.emitPMFlowAuditPath);
  }

  removePMAuditFile(pmType: string): Observable<any> {
    return this.apiService.post$(this.removePMAuditFilePath, { pmType: pmType });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  saveServerConfig(payload: any): Observable<any> {
    return this.apiService.post$<any>(this.saveServerConfigPath, { config: payload });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  transferDevices(payload: any): Observable<any> {
    return this.apiService.post$<any>(this.transferDevicesPath, { reqData: payload });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadJmepsBulkConfigFile(formData: FormData): Observable<any> {
    return this.http.post(this.uploadJmepsBulkConfigFilePath, formData);
  }
}
